import { Modal } from "antd";
import { type FC } from "react";
import styled from "styled-components";
import { UserProfileForm, UserProfileFormProps } from "./profile-form";
import { AppText } from "common/base/text/index";
import { useProfileStore } from "store";

const Root = styled.div`
    gap: 20px;
`

export interface ProfileEditProps extends Pick<UserProfileFormProps, "onSave">{
    
}
const ProfileEdit:FC<ProfileEditProps> = ({
    onSave
}) => {
    const { isEditModalOpen, closeEditModal, setUser, user } = useProfileStore();
    return (
        <Modal open={isEditModalOpen } onCancel={closeEditModal} footer={null}>
            <Root  style={{ padding: 20 }}>
                <AppText size={32}>Edit Profile</AppText>
                <AppText as="p">Update your profile information</AppText>
                <UserProfileForm 
                    {...{
                        user,
                        async onSave(data) {
                            const newUser = await onSave(data)
                            if(newUser){
                                setUser({...user, ...newUser})
                                closeEditModal()
                            }
                            return newUser;
                        },
                    }} 
                />
            </Root>
        </Modal>
    )
}

export default ProfileEdit;